import script from "./RouterItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RouterItem.vue?vue&type=script&setup=true&lang=js"

import "./RouterItem.vue?vue&type=style&index=0&id=397fcf64&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-397fcf64"]])

export default __exports__